var homeCarouselCol1 = Swiper;
var homeCarouselCol2 = Swiper;
var musicCarousel    = Swiper;
var storeCarousel    = Swiper;
var storeCarouselArticles = Swiper;
var init = false;

window.addEventListener('load', function() {
});

initMobileCarousel();

window.addEventListener('resize', function() {
  initMobileCarousel();
});


jQuery(function($){
  let checkCookie = getCookie('___allowCookies');
  let menuItems = new Swiper ('#menuItems', {
    direction: 'vertical',
    centeredSlides: true,
    spaceBetween: 10,
    centeredSlides: true,
    spaceBetween: 10,
    allowTouchMove: false,
    slidesPerView: 5,
    // speed: 200,
    loop: true,
    mousewheel: true,
    followFinger: false,
    longSwipes: false,
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    // breakpoints: {
    //   768: {

    //   }
    // }
  });

  setCardBackgroundImage();

  // Force to do one slide per swipe only
  menuItems.on('touchEnd', function(){
    document.addEventListener('swiped-up', function(e) {
      menuItems.slidePrev();
    });

    document.addEventListener('swiped-down', function(e) {
      menuItems.slideNext();
    });
  });

  // $(window).on('load', function() {
    setTimeout(() => {
      animateOnEnter();
      if (checkCookie == '') $('#alertCookie').removeClass('d-none');
    }, 800);
  // });

  $(document).on('click', '#menuItems .swiper-slide', function(e) {
    e.stopPropagation();
    let index = $(this).index();
    if (menuItems.activeIndex === index + 1) {
      e.preventDefault();
      menuItems.slidePrev();
    }
    else if (menuItems.activeIndex === index - 1) {
      e.preventDefault();
      menuItems.slideNext();
    }
  });

  $(document).on('click', '#toggleMenu', function(e) {
    $('.hamburger').toggleClass('is-active');
    if ($('body').hasClass('menu--is-hidden')) {
      showMenu(true);
    } else {
      showMenu(false);
    }
    e.preventDefault();
  });

  $(document).on('click', '.menu__link', function(e) {
    let link = $(this).attr('href');
    setTimeout(() => {
      animateMenuOnLeave(link);
    //   showMenu(false);
    //   setTimeout(() => {
    //     animateOnLeave(link);
    //   }, 800);
    }, 800);
    e.preventDefault();
  });

  $(document).on('click', '#acceptCookie', function(e) {
    $('#alertCookie').fadeOut();
    setCookie('___allowCookies', 'yes', 1);
    e.preventDefault();
  });

  $(document).on('click', '.footer__link', function (e){
    if (/#/.test(this.href)) {
      let hash = $(this).attr('href');
      // $('.footer__contents').addClass('is-loading');
      $('.footer__content').fadeOut();
      $(hash).fadeIn();
      $('html, body').animate({ scrollTop: $('#footer-contents').offset().top - 10 });
      e.preventDefault();
    }
  });

  $(document).on('click', '.link-animation', function(e){
    // if (!$(this).hasClass('menu__link') || $(this).hasClass('product__atc') || $(this).hasClass('remove-basket-item') || !$(this).hasClass('copy-contact') ) {
      if (!/#/.test(this.href)) {
        let link = $(this).attr('href');
        animateOnLeave(link);
        e.preventDefault();
      }
    // }
  });

  $(document).on('click', '.close-adpopup', function(){
    $('.modal--ads').removeClass('show');
  });

  $(document).on('hidden.bs.modal', '.modal--ads', function(){
    $('.ads-video').attr('src', '');
  });

  $(document).on('click', '.ads--popup', function(e){
    let modalKey = $(this).data('modal-key');
    let $modal = $('#adsModal'+modalKey);
    let videoSource = $modal.find('.modal-dialog').data('video-src');

    if (videoSource.length > 0) {
      $modal.find('.ads-video').attr('src', videoSource);
    }

    e.preventDefault();
  });


  $(document).on('click', '.modal-close-ads', function(e) {
    let modalAdsType =  $(this).parents('.modal-ads').data('modal-type');
    $('.modal-ads').removeClass('modal-ads--is-visible');
    setTimeout(function(){
      if (modalAdsType == 'video') {
        $('.ads-video').attr('src', '');
      }
      $('body').removeClass('menu--is-visible');
    }, 800);
  });

  $(window).on('load resize', function() {
    if ($(window).width() > 767) {
      $('.card__item--news').hover(function(){
        // $('.page__wrapper').addClass('page__wrapper--has-overlay');
        let linkColor = $(this).find('li.category a').data('color');
        $(this).find('.card__title a').css('color', linkColor);
        $(this).find('.card__title').css('color', linkColor);
      }, function() {
        // $('.page__wrapper').removeClass('page__wrapper--has-overlay');
        $(this).find('.card__title a').css('color', '#FFFFFF');
        $(this).find('.card__title').css('color', '#FFFFFF');
      });

      $('.card__item--video').hover(function(){
        // $('.page__wrapper').addClass('page__wrapper--has-overlay');
        $(this).find('.card__title').css('text-decoration', 'underline');
        $(this).find('.card__duration').css('text-decoration', 'underline');
      }, function() {
        // $('.page__wrapper').removeClass('page__wrapper--has-overlay');
        $(this).find('.card__title').attr('style', '');
        $(this).find('.card__duration').attr('style', '');
      });
    }
  });

});

function setCardBackgroundImage() {
  var imageUrl;
  $('.card__image--as-background').each(function (){
    if ($(this).hasClass('card__image--news')) {
      imageUrl = $(this).find('img.img-news--desktop');
    } else {
      imageUrl = $(this).find('img').attr('src');
    }

    $(this).css('background-image', 'url('+ imageUrl + ')' );
  });
}

function animateOnEnter() {
  let tl = gsap.timeline({
    onComplete: function () {
      // $('#loading').fadeOut();
      $('body').addClass('animation--is-finished');
    }
  });

  tl.to('.loading .bar', {
      duration: 0.1,
      stagger: 0.1,
      reversed: true,
      backgroundColor:"#ffffff",
    })
    .to('#loading', { translateY: '-100%' })
    .to('.navigation__bar', { opacity: 1 });
}

function animateOnLeave(link) {
  let tl = gsap.timeline({
    onComplete: function () {
      // $('.loading-gif').fadeOut();

      setTimeout(() => {
        document.location.href = link;
      }, 100);
    }
  });

  $('.loading__ladder .bar').removeAttr('style');
  // $('.loading-gif').fadeOut();
  tl.to('#loading', { translateY: '0%', dutration: 0.2 });
}

function animateMenuOnLeave(link) {
  let tl = gsap.timeline({
    onComplete: function () {
      setTimeout(() => {
        document.location.href = link;
      }, 100);
    }
  });

  $('.loading__ladder .bar').removeAttr('style');
  tl.to('#loading', { translateY: '0%' });
}

function animateAdsOnLeave() {

}

function showMenu(show) {
  let tl = gsap.timeline();
  if (show) {
    $('body').removeClass('menu--is-hidden');
    $('body').addClass('menu--is-visible');

    tl.to('#navigationBar', { bottom: '0' })
      .to('#navigationMenu', { translateY: '0%' }, "-=0.5");

    gsap.to('.nav__actions--left', { opacity: 0 });
    gsap.to('.nav-item--search', { opacity: 0 });

  } else {
    $('body').addClass('menu--is-hidden');
    $('body').removeClass('menu--is-visible');

    tl.to('#navigationBar', { bottom: 'auto' })
      .to('#navigationMenu', { translateY: '-100%' }, "-=0.5");

    gsap.to('.nav__actions--left', { opacity: 1, delay: 0.5 });
    gsap.to('.nav-item--search', { opacity: 1, delay: 0.5 });
  }
}

function setCookie(cookieName, cookieValue, expirationDays) {
  let d = new Date();
  d.setTime(d.getTime() + (expirationDays*24*60*60*1000));
  let expires = 'expires='+ d.toUTCString();
  document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
}

function getCookie(cookieName) {
  let name = cookieName + '=';
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function initMobileCarousel() {
  if ($(window).width() <= 992) {
    if (!init) {
      init = true;
      homeCarouselCol1 = new Swiper('.carousel--home-col1', {
        slidesPerView: 1,
        spaceBetween: 15,
        freeMode: true,
        breakpoints: {
          640: {
            slidesPerView: 2
          }
        }
      });
      homeCarouselCol2 = new Swiper('.carousel--home-col2', {
        slidesPerView: 2,
        spaceBetween: 15,
        freeMode: true,
        breakpoints: {
          640: {
            slidesPerView: 2
          }
        }
      });
      storeCarouselArticles = new Swiper('.carousel--store-articles', {
        slidesPerView: 1,
        spaceBetween: 0,
        freeMode: true,
        centeredSlides: true,
        on: {
          init: function (){
            if ($(window).width() <= 640) {
              this.slideNext();
            }
          }
        },
        breakpoints: {
          640: {
            slidesPerView: 2
          }
        }
      });
    }
  }

  else {
    var totalCarouselCol1 = homeCarouselCol1.length;
    var totalCarouselCol2 = homeCarouselCol2.length;
    var totalstoreCarouselArticles = storeCarouselArticles.length;

    // Destroy Carousel - 1 column
    if (totalCarouselCol1 > 1 ) {
      for(let a = 0; a < totalCarouselCol1; a++) {
        homeCarouselCol1[a].destroy();
      }
    } else if(totalCarouselCol1 == 1) {
      homeCarouselCol1.destroy();
    }

    // Destroy Carousel - Store
    if (totalstoreCarouselArticles > 1 ) {
      for(let a = 0; a < totalstoreCarouselArticles; a++) {
        storeCarouselArticles[a].destroy();
      }
    } else if(totalstoreCarouselArticles == 1) {
      storeCarouselArticles.destroy();
    }

    // Destroy Carousel - 2 columns
    if (totalCarouselCol2 > 1 ) {
      for(let a = 0; a < totalCarouselCol2; a++) {
        homeCarouselCol2[a].destroy();
      }
    } else if(totalCarouselCol2 == 1) {
      homeCarouselCol2.destroy();
    }

    init = false;
  }
}
